import * as fabric from "fabric";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../hook/redux";
import { createCustomRectPath } from '../../../Canvas/imagesUtils';


const STROKE_COLOR = process.env.STROKE_COLOR;

function CornerSelector( { canvas } ) {
  const { selectedLayout, currentData, scale } = useAppSelector( ( state ) => state.editor );

  const {layoutData} = currentData;

  const [ activeCorner, setIsCornerActive ] = useState( false );
  const [ borderRadius, setBorderRadius ] = useState( 0 );

  const dispatch = useAppDispatch();


  const images =
    canvas && canvas._objects
      ? canvas._objects.filter((object) => object.clipPath)
      : [];

      
      useEffect( () => {
        const radius = images[0]?.clipPath.rx;
        setBorderRadius(radius);

  }, [layoutData] );

  useEffect(() => {
    if (borderRadius === 0) {
      setIsCornerActive(false);
    } else {
      setIsCornerActive(true);
    }
  }, [borderRadius]);


  /**
   * Toggles the corner radius of the selected layout elements on the canvas.
   * If the current border radius is 0, it sets it to 20, otherwise it sets it to 0.
   * It also adds a blinking border effect to the updated elements.
   * The function updates the border radius state in the Redux store and the current data fabric array.
   */
  const toggleCorner = () => {

    const newRadius = borderRadius === 0 ? 20 * scale : 0;

    canvas._objects.forEach(obj => {
      if (obj.clipPath) {
        if (obj.clipPath instanceof fabric.Rect) {
          obj.clipPath.set({
            rx: newRadius,
            ry: newRadius
          });
        } else if (obj.clipPath instanceof fabric.Path) {
          const width = obj.clipPath.width;
          const height = obj.clipPath.height;
          
          const isRounded = obj.isRounded;
          const pathData = createCustomRectPath(width, height, {
            topLeft: isRounded ? 0 : obj.cornerTopLeft * scale,
            topRight: isRounded ? 0 : obj.cornerTopRight * scale,
            bottomLeft: isRounded ? 0 : obj.cornerBottomLeft * scale,
            bottomRight: isRounded ? 0 : obj.cornerBottomRight * scale,
          });

          const clipRect = new fabric.Path(pathData, {
            left: obj.clipPath.left,
            top: obj.clipPath.top,
            width: obj.clipPath.width,
            height: obj.clipPath.height,
            originX: obj.clipPath.originX,
            originY: obj.clipPath.originY,
            absolutePositioned: true,
            angle: obj.clipPath.angle,
            objectCaching: false,
            isSelectionBorder: true
          });
      
          obj.clipPath = clipRect;
          obj.set({
            isRounded: !isRounded,
          })
        }
      }

      if (obj.type === "image" && (obj.idx || obj.idx === 0)) {
        const targetObj = obj.clipPath || obj;
        const blinkingBorder = new fabric.Rect( {
          left: targetObj.left,
          top: targetObj.top,
          width: targetObj.width,
          height: targetObj.height,
          rx: newRadius,
          ry: newRadius,
          originX: targetObj.originX,
          originY: targetObj.originY,
          absolutePositioned: true,
          stroke: STROKE_COLOR,
          strokeDashArray: [ 10, 5 ],
          strokeWidth: 4,
          fill: 'transparent',
          selectable: false,
          evented: false,
          angle: targetObj.angle,
          isSelectionBorder: true
        } );

        canvas.add( blinkingBorder );

        let opacity = 1;
        let count = 0;
        const maxBlinks = 3;

        /**
         * Toggles the visibility (opacity) of a blinking border on a canvas.
         *
         * The `blink` function alternates the opacity of the `blinkingBorder` object between visible (1) and invisible (0),
         * rendering these changes to the `canvas` object. It executes recursively using a timeout
         * until the number of blinks reaches the specified `maxBlinks` value.
         *
         * Upon completing the blinking sequence, the `blinkingBorder` is removed from the canvas.
         */
        const blink = () => {
          opacity = opacity === 1 ? 0 : 1;
          blinkingBorder.set( 'opacity', opacity );
          canvas.renderAll();

          count++;
          if ( count < maxBlinks ) {
            setTimeout( blink, 400 );
          } else {
            canvas.remove( blinkingBorder );
            canvas.renderAll();
          }
        };

        blink();
      }
    });

    canvas.renderAll();

    dispatch({
      type: "editor/updateBorderRadiusState",
      payload: {
        id: selectedLayout,
        borderRadius: newRadius,
      }
    });

    dispatch({
      type: "editor/updateCurrentDataFabricArray",
      payload: {
        layoutId: selectedLayout,
        fabricElements: JSON.stringify(canvas.toJSON()),
      }
    });

    setIsCornerActive(!activeCorner);
  };

  return (
    <>
      <a className="toolbar-button" onClick={() => toggleCorner()}>
        <img
          src={activeCorner
               ? "https://dk2wbmtb9x9n8.cloudfront.net/assets/v2017/img/btn-coins-layout-rond-v4.png"
               : "https://dk2wbmtb9x9n8.cloudfront.net/assets/v2017/img/btn-coins-layout-carre-v4.png" }
          style={{width: "80%", margin: "0 auto"}}
          alt="corner-selector"
        />
      </a>
    </>
  );
}

export default CornerSelector;
